<template>
<div class="content-class">
	<v-tabs color="black" dark slider-color="primary">
		<v-tab ripple>Variables</v-tab>
	</v-tabs>
	<bot-variable-list :url="`botVariables?filter=$or:[bot:$eq:${$route.params.botId};bot:$exists:false]`">
	</bot-variable-list>
</div>
</template>

<script>
import BotVariableList from '../../components/botVariables/botVariable.list'

export default {
	components: { BotVariableList }
}
</script>

<style lang="scss">
.content-class {
    width: 100%;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/botVariables/botVariable.list.vue